export const seo = ({
  title,
  description,
  keywords,
  image,
  robots,
  type = "website",
}: {
  title: string;
  description?: string;
  image?: string;
  keywords?: string;
  robots?: string;
  type?: "website" | "product" | "article";
}) => {
  const tags = [
    { title },
    { name: "description", content: description },
    { name: "keywords", content: keywords },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: description },
    { name: "og:type", content: type },
    { name: "og:title", content: title },
    { name: "og:description", content: description },
    ...(image
      ? [
          { name: "twitter:image", content: image },
          { name: "twitter:card", content: "summary_large_image" },
          { name: "og:image", content: image },
        ]
      : []),
    ...(robots ? [{ name: "robots", content: robots }] : []),
  ];

  return tags;
};
